import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';

/**
 * The customer's contact as held on the job (`Job.supervisor`) — a snapshot taken when the user
 * picked it, so a document reprints the same values however CRM changes afterwards. Distinct from
 * `jobCustomerContact`, which resolves the customer record's primary contact live at merge time.
 */
@MergeSchema({
    entity: ActivityEntityName.Contact
})
export class JobCustomerContactMergeData {

    @MergeField({
        displayName: "Full Name"
    })
    name: string;

    @MergeField()
    email: string;

    @MergeField()
    mobile: string;

    @MergeField({
        displayName: "Work Phone"
    })
    workPhone: string;

    @MergeField({
        displayName: "Home Phone"
    })
    phone: string;
}

export const JobCustomerContactMergeSchema = getSchema(JobCustomerContactMergeData);
